module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAEAQMAAACTPww9AAAAA3NCSVQICAjb4U/gAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP/AOW3MEoAAAAJcEhZcwAAAsQAAALEAVuRnQsAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDUvMDIvMTGI8AGbAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAABBJREFUCJljuMCwgKGAYQEACsgCgf/CoqoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/overlays/07.png
// module id = 321
// module chunks = 2